import { Navigate } from "react-router-dom";

export const API_URL = "https://southcentraldev.com/api/bs";
export const BILLING_API_URL = "https://southcentraldev.com/api/billing";
export const MAIN_API_URL = "https://southcentraldev.com/api/admin";
export const EMAIL_API_URL = "https://southcentraldev.com/api/email";


// export const API_URL = "http://127.0.0.1:8000/api/bs";
// export const BILLING_API_URL = "http://127.0.0.1:8000/api/billing";
// export const MAIN_API_URL = "http://127.0.0.1:8000/api/admin";

export const SITE = "plot-division";

export const getAccessToken = () => localStorage.getItem("access");
export const getRefreshToken = () => localStorage.getItem("refresh");

export function hasAnyAuthToken() {
  return !!(getAccessToken() || getRefreshToken());
}

export function clearAuthStorage() {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("user_id");
  localStorage.removeItem("fb_plan");
  localStorage.removeItem("is_staff");
  localStorage.removeItem("is_superuser");
}

export async function refreshAccessToken() {
  const refresh = getRefreshToken();
  if (!refresh) return getAccessToken();

  try {
    const response = await fetch(`${MAIN_API_URL}/token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh }),
    });

    if (!response.ok) {
      console.warn("Refresh token expired or invalid");
      clearAuthStorage();
      return null;
    }

    const data = await response.json();

    if (data?.access) {
      localStorage.setItem("access", data.access);
    }

    // IMPORTANT: save rotated refresh token if backend returns one
    if (data?.refresh) {
      localStorage.setItem("refresh", data.refresh);
    }

    return data?.access || getAccessToken();
  } catch (err) {
    console.error("Error refreshing token:", err);
    return getAccessToken();
  }
}

export async function authFetch(url, options = {}) {
  let access = getAccessToken();

  options.headers = {
    ...(options.headers || {}),
    ...(access ? { Authorization: `Bearer ${access}` } : {}),
    "Content-Type": "application/json",
  };

  let response = await fetch(url, options);

  if (response.status === 401) {
    const newAccess = await refreshAccessToken();
    if (newAccess) {
      options.headers.Authorization = `Bearer ${newAccess}`;
      response = await fetch(url, options);
    }
  }

  return response;
}

export function isLoggedIn() {
  return !!(getAccessToken() || getRefreshToken());
}

export const isStaff = () => localStorage.getItem("is_staff") === "1";
export function isSuperUser() {
  return localStorage.getItem("is_superuser") === "1";
}

export default function V1HiddenRoute({ inV1, children }) {
  if (!isLoggedIn()) return <Navigate to="/login" replace />;
  if (inV1 && !isStaff()) return <Navigate to="/401" replace />;
  return children;
}